import { RoadStructuresOverheadSignagesAttributeConvert } from "@/attribute/convert/RoadStructuresOverheadSignagesAttributeConvert";
import { FeatureType } from "../define/FeatureType";
import { AbstractRoadStructuresLayerFactory } from "./AbstractRoadStructuresLayerFactory";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";

/**
 * 点検データ(⾨型標識等)レイヤ 出力クラス
 */
export class RoadStructuresOverheadSignagesLayerFactory extends AbstractRoadStructuresLayerFactory {
  /**
   * API取得用URL
   */

  URL_API =
    process.env.VUE_APP_ROAD_STRUCTURES_DB_API_URL + "/overhead_signages";

  /**
   * アイコンURL
   */

  URL_LAYER_ICON = "./icon/layer/structures-overhead_signages.png";

  /**
   * アイコンのサイズ
   */

  ICON_SIZE = 1;

  /**
   * 最大ズームレベル
   */

  LAYER_MAX_ZOOMLEVEL = 18;

  /**
   * 最小ズームレベル
   */

  LAYER_MIN_ZOOMLEVEL = 11;

  /**
   * コンテキストメニュー名称
   */
  CONTEXT_MENU_NAME = "点検DB_門型標識等";

  /**
   * 対象データ出力レイヤ
   */
  FEATURE_TYPE = FeatureType.OverheadSignages;

  /**
   * 対象Attribute変換クラス
   */
  ATTRIBUTE_CONVERT = (geoJSON: any) =>
    new RoadStructuresOverheadSignagesAttributeConvert(
      geoJSON
    ) as IAttributeConvert;
}
